// Shared state + copy for the OAuth / OIDC sign-in flows (OAuthProviders,
// OAuthCallback, Login, ConnectedAccounts).

// sessionStorage keys written before redirecting to the provider and read
// back on /oauth/callback, so the callback knows which provider answered and
// whether this was a "connect to my account" flow.
export const OAUTH_PROVIDER_KEY = 'factory_oauth_provider'
export const OAUTH_LINK_KEY = 'factory_oauth_link'

export function rememberOAuthFlow(provider: string, link = false): void {
  sessionStorage.setItem(OAUTH_PROVIDER_KEY, provider)
  if (link) {
    sessionStorage.setItem(OAUTH_LINK_KEY, '1')
  } else {
    sessionStorage.removeItem(OAUTH_LINK_KEY)
  }
}

// Reads and clears the remembered flow. Defaults to GitHub: GitHub App
// installs and flows started before this key existed land here without one.
export function takeOAuthFlow(): { provider: string; link: boolean } {
  const provider = sessionStorage.getItem(OAUTH_PROVIDER_KEY) || 'github'
  const link = sessionStorage.getItem(OAUTH_LINK_KEY) === '1'
  sessionStorage.removeItem(OAUTH_PROVIDER_KEY)
  sessionStorage.removeItem(OAUTH_LINK_KEY)
  return { provider, link }
}

export function providerLabel(name: string): string {
  const labels: Record<string, string> = {
    github: 'GitHub',
    google: 'Google',
    tynhub: 'TynHub',
  }
  return labels[name] || (name ? name.charAt(0).toUpperCase() + name.slice(1) : 'OAuth')
}

// Messages for the `code` the API returns (and /login?error=<code>).
export const oauthErrorMessages: Record<string, string> = {
  oauth_no_email: 'Could not retrieve your email from GitHub. Please make sure you have a verified email on your GitHub account.',
  oauth_denied: 'OAuth authorization was denied.',
  oauth_failed: 'OAuth authentication failed. Please try again.',
  oauth_link_required: 'An account with this email already exists. Sign in with your password, then connect TynHub from your account settings.',
  oauth_email_unverified: 'Your TynHub email address is not verified. Verify it on TynHub, then try again.',
  oauth_account_in_use: 'That TynHub account is already connected to a different Factory account.',
  oauth_provider_already_connected: 'Your account is already connected to a different TynHub account.',
  oauth_provider_unavailable: 'The sign-in provider is unavailable right now. Please try again shortly.',
  internal: 'An internal error occurred. Please try again.',
}
